import { /* makeStyles, Theme, */ Typography } from "@material-ui/core";
import React from "react";
import navigationImage from "./Assets/navigation.svg";
import videoImage from "./Assets/video.svg";
import talentImage from "./Assets/talent.svg";
import Categories from "./Categories";
import CategoryData from "./CategoryData";
import ContactInformation from "./WDContactInformation";

// const useStyles = makeStyles((theme: Theme) => ({}));

const categories = [
    {
        title: "Recruiting",
        icon: navigationImage,
        subCategories: [
            {
                icon: videoImage,
                mainLinks: [],
                jobAids: [
                    {
                        title: "Manage Candidates",
                        link: "https://d1xzj63c8dqlov.cloudfront.net/document/002c7b69-18ed-49f2-9706-c39abf1798d2",
                    },
                    {
                        title: "The Recruiting Navigation Toolbar",
                        link: "https://d1xzj63c8dqlov.cloudfront.net/document/fb0cd238-d8bc-4d80-b76c-87ec3a7bad96",
                    },
                    {
                        title: "Dashboard and Analytic Report",
                        link: "https://d1xzj63c8dqlov.cloudfront.net/document/7b7f530b-ecd7-4322-afc2-ad78aa9b1763",
                    },
                ],
            },
        ],
    },
    {
        title: "Recruiting Training Sessions",
        icon: talentImage,
        subCategories: [
            {
                icon: videoImage,
                mainLinks: [
                    {
                        title: "Workday Recruiting Session 1",
                        link: "https://d1xzj63c8dqlov.cloudfront.net/video/715db32c-e121-4311-bb7a-ffcf09c9bfb8",
                    },
                    {
                        title: "Workday Recruiting Session 2",
                        link: "https://d1xzj63c8dqlov.cloudfront.net/video/5f661073-a651-41c0-9a2d-4dc2752bcdb7",
                    },
                    {
                        title: "Workday Recruiting Session 3",
                        link: "https://d1xzj63c8dqlov.cloudfront.net/video/a658a625-19e1-47f9-9550-a09bcffb3fed",
                    },
                    {
                        title: "Workday Recruiting Session 4",
                        link: "https://d1xzj63c8dqlov.cloudfront.net/video/74b4a66b-7617-4b43-8c83-ba59b14aa3da",
                    },
                ],
                jobAids: [],
            },
        ],
    },
] as CategoryData[];

export default function RecruiterLinks() {
    // const classes = useStyles();

    return (
        <React.Fragment>
            <Typography variant="h4">Quick Links for Recruiters</Typography>

            <br />
            <Categories data={categories} />
            <br />

            <ContactInformation />
        </React.Fragment>
    );
}
